import { weatherStore } from "../stores";

export const useWeatherStore = () => weatherStore;
